import * as _ from 'lodash';

import { Finding, FindingCollection } from '../../Findings';
import { CategoryCollection, Category } from '../../Categories';
import { Id_category, Id_floor } from '../../api/Identifiers';
import { get_state, did_change, did_any_change } from '../../redux/State'
import { Dispatcher, dispatch_action } from '../../redux/Dispatcher'
import { Actions, Action } from '../../redux/Actions'
import { Keys } from '../../redux/Datastore'
import { Configuration } from '../../Configuration';
import { CssElement } from '../../css_utils';
import { DrawingsCollection } from '../../drawings/DrawingsCollection';
import { Floor } from '../../Floor';
import { get_current_view_port_map } from '../map/map_area';
import { Rectangle } from '../../Rectangle';


let menu_rows_count: number = 0;

function append_menu_row(li: HTMLLIElement): void {
    const ul = UI.menu_findings_content_list_ul;
    if (li && ul) {
        ul.appendChild(li);
        menu_rows_count++;
    }
}

function li_from_html(html: string): HTMLLIElement {
    return <HTMLLIElement>$.parseHTML(html.trim())[0];
}

class UI {
    public static get menu_findings_content_list_ul(): HTMLUListElement {
        return <HTMLUListElement>document.getElementById('menu_findings_content_list');
    }
    public static get menu_findings_header(): HTMLElement {
        return document.getElementById('menu_findings_header');
    }
    public static toggle_selected(li: HTMLLIElement, is_selected: boolean) {
        if (is_selected) {
            if (!li.classList.contains("selected")) {
                li.classList.add("selected");
            }

        }
        else {
            li.classList.remove("selected");
        }
    }
    public static get menu_print_findings(): HTMLElement {
        return document.getElementById('menu_print_findings');
    }
}

function remove(array: any[], elementToRemove: any): any[] {
    return array.filter(function (el) {
        //console.error(`${el} !== ${elementToRemove} => ${el !== elementToRemove}`);
        return el !== elementToRemove
    });
}

export interface FindingsMenuItemJSON {
    label: string,
    idCategory: string,
    count: number,
    icon: string
}

function toggleFindings(findingCategory: number, toggle_state: boolean) {
    let menuItemAnchor = $(`#id_finding__${findingCategory}`)

    // toggle the menu item
    if (menuItemAnchor.parent().prop("tagName") === "LI") {
        menuItemAnchor.parent().toggleClass("selected", toggle_state);
    }
}

// it is assumed that the findings are already filtered down by floor
export function build_findings_menu_json(floor_findings: FindingCollection, categories: CategoryCollection): FindingsMenuItemJSON[] {
    let r: FindingsMenuItemJSON[] = [];
    //let temp: string[] = floor_findings.get_categories();
    let temp: any = {}
    floor_findings.findings.forEach((finding: Finding) => {
        let category_key: string = finding.category.toString()
        if (!temp[category_key]) {
            let category_label: string = category_key;
            let category: Category = categories.find(finding.category);
            if (category) {
                category_label = category.label;
            }
            temp[category_key] = <FindingsMenuItemJSON>{
                label: category_label,
                idCategory: category_key,
                count: 0,
                icon: finding.icon
            }
        }
        temp[category_key].count++;
    })

    Object.keys(temp).forEach((key: string) => {
        r.push(temp[key]);

    })

    return r;

}


function force_draw_findings_menu() {
    let findings_menu: FindingsMenuItemJSON[] = get_state().get_array(Keys.MENU_FINDINGS_CONTENT, []);
    let findings_selected: string[] = get_state().get_array(Keys.MENU_FINDINGS_SELECTED, []);
    const findings_list = document.getElementById("menu_findings_content_list");
    if (!findings_list) {
        return;
    }

    findings_list.innerHTML = "";  // remove all findings from the menu before building the menu.
    menu_rows_count = 0;
    findings_menu.sort(function (a, b) {
        if (a.label < b.label)
            return -1;
        if (a.label > b.label)
            return 1;
        return 0;
    });

    findings_menu.forEach((menuItem: FindingsMenuItemJSON) => {
        let id_category: string = menuItem.idCategory;
        let menu_item_id: string = `id_finding__${id_category}`;

        var html = `
<li style='padding: 2px; padding-left: 15px; border-radius: 0px' class='list-group-item clearfix'>
<span>
    <a href='#' id='${menu_item_id}' class='waves-effect' id_category=${id_category}>
        <img src='${menuItem.icon}'  width='20' height='20' />
        <i class='material-icons'> ${menuItem.label}</i>
    </a>
</span>
<span class='badge'>${menuItem.count}</span>
</li>
`

        append_menu_row(li_from_html(html));
        let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById(`${menu_item_id}`);
        if (anchor) {
            anchor.onclick = onclick_menu_item;
        }
    });

    const ul = document.getElementById('menu_findings_content_list') as HTMLUListElement;
    if (ul && findings_selected && findings_selected.length > 0) {
        const selectedIds = findings_selected.map(x => x && x.toString ? x.toString() : String(x));
        for (let i = 0; i < ul.children.length; i++) {
            const li = ul.children[i] as HTMLLIElement;
            const anchor = li.querySelector('a[id_category]');
            if (anchor) {
                const id_category = anchor.getAttribute('id_category');
                if (selectedIds.indexOf(id_category) > -1) {
                    li.classList.add('selected');
                } else {
                    li.classList.remove('selected');
                }
            }
        }
    }



    if (menu_rows_count > 0) {
        // TODO: Split the <a> tag such that the glyphicon can be styled to stay 
        //       black on hover. The text link should underline and look like a 
        //       clickable link.

        let select_all_html: string = `
        <li class='list-group-item' style='padding: 2px' >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href='#' id='findings_menu_selectall_icon' >
            <span class= 'glyphicon glyphicon-check'></span>
        </a>
        <a href='#' id='findings_menu_selectall' >Select All</a>
        </li>`

        let clear_all_html: string = `
        <li class='list-group-item' style="padding: 2px" >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="#" id="findings_menu_clear_icon">
            <span class= "glyphicon glyphicon-unchecked"></span>
        </a>
        <a href="#" id="findings_menu_clear">Clear All</a>
        </li>`;

        append_menu_row(li_from_html(select_all_html))
        const selectAll = document.getElementById('findings_menu_selectall');
        const selectAllIcon = document.getElementById('findings_menu_selectall_icon');
        if (selectAll) {
            selectAll.onclick = onclick_select_all;
        }
        if (selectAllIcon) {
            selectAllIcon.onclick = onclick_select_all;
        }

        append_menu_row(li_from_html(clear_all_html))
        const clear = document.getElementById('findings_menu_clear');
        const clearIcon = document.getElementById('findings_menu_clear_icon');
        if (clear) {
            clear.onclick = onclick_clear_all;
        }
        if (clearIcon) {
            clearIcon.onclick = onclick_clear_all;
        }

    }
    if (!Configuration.read_only_mode) {
        let add_finding_html: string = `
        <li class='list-group-item' style="padding: 2px" >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a href="#" id="findings_menu_new_icon"   >
            <span class= "glyphicon glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" id="findings_menu_new"   >
            Create a new finding
        </a>
        </li>`


        append_menu_row(li_from_html(add_finding_html))
        const createNew = document.getElementById('findings_menu_new');
        const createNewIcon = document.getElementById('findings_menu_new_icon');
        if (createNew) {
            createNew.onclick = onclick_create_new;
        }
        if (createNewIcon) {
            createNewIcon.onclick = onclick_create_new;
        }
    }

    if (UI.menu_findings_header) {
        if (menu_rows_count == 0) {
            new CssElement(UI.menu_findings_header).visibility = false;
        }
        else {
            new CssElement(UI.menu_findings_header).visibility = true;
        }
    }

    // show the Print PDF button
    if (UI.menu_print_findings) {
        if (!Configuration.isPdfPrint) {
            new CssElement(UI.menu_print_findings).visibility = false;
        }
        else {
            new CssElement(UI.menu_print_findings).visibility = true;
            UI.menu_print_findings.onclick = onclick_print_findings;
        }
    }
    
}

export function draw_findings_menu() {
    if (!Configuration.findings_feature_enabled) {
        return;
    }
    if (did_change(Keys.MENU_FINDINGS_EXPANDED)) {
        let expanded: boolean = get_state().get_boolean(Keys.MENU_FINDINGS_EXPANDED)
        if (expanded) {
            $("#menu_findings_header_chevron").attr("class", "glyphicon glyphicon-chevron-down")
            $("#menu_findings_content").show(400)
        }
        else {
            $("#menu_findings_header_chevron").attr("class", "glyphicon   glyphicon-chevron-right")
            $("#menu_findings_content").hide(400)
        }
    }

    // if the menu findings content changed, redraw the findings menu
    if (did_any_change([Keys.KEY_STATE_FIRST_RUN,
    Keys.MENU_FINDINGS_CONTENT,
    Keys.ID_FLOOR,
    ])) {
        force_draw_findings_menu();
    }


    if (did_change(Keys.MENU_FINDINGS_SELECTED)) {
        force_draw_findings_menu();
    }
}

function onclick_clear_all(ev?: MouseEvent) {
    if (ev) { ev.preventDefault(); }
    dispatch_action(Action.toggle_all_findings_categories(false))
}

function onclick_menu_item(this: HTMLElement, ev: MouseEvent): any {
    ev.preventDefault();
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>this;
    let id_category = Id_category.wrap(anchor.getAttribute("id_category"))
    if (id_category) {
        // we must get a fresh copy of the state b/c this function runs
        // in a completely different context.
        let was_selected: boolean = get_state().selected_findings_categories.some((cat: Id_category) => {
            return cat && cat.equals(id_category)
        })
        let is_selected: boolean = !was_selected
        Dispatcher.dispatch_action(Action.toggle_finding_category_selected(id_category, is_selected));
    }
}

function onclick_select_all(ev?: MouseEvent) {
    if (ev) { ev.preventDefault(); }
    dispatch_action(Action.toggle_all_findings_categories(true))
}

function onclick_create_new(ev?: MouseEvent) {
    if (ev) { ev.preventDefault(); }
    Dispatcher.dispatch(Actions.SET_ADD_FINDINGS_STATE, true);
}

function create_findings_print_object(): any {
    let id_drawing = get_state().id_drawing;
    let findings_obj: any = {};
    //     "id_drawing" : id_drawing,
    //     "report_title" : "lalalalala"
    // };
    let findings: any = [];
    let findings_menu: FindingsMenuItemJSON[] = get_state().get_array(Keys.MENU_FINDINGS_CONTENT, []);
    let selected_findings_categories: Id_category[] = get_state().selected_findings_categories;
    let filtered_findings: Finding[] = get_state().findings.get_findings_on_floor(get_state().id_floor).findings;
    //let index = 1;
    if (selected_findings_categories.length > 0) {
        selected_findings_categories.forEach((category: Id_category) => {
            filtered_findings.forEach((finding: Finding) => {
                if (!finding.has_findingNumber){
                    return;
                }
                if (finding.id_category.equals(category)) {
                    let xCoord: number = 1;
                    let yCoord: number = 1;
                    let p1x: number = get_state().drawing_p1p2.P1.X;
                    let p1y: number = get_state().drawing_p1p2.P1.Y;
                    let p2x: number = get_state().drawing_p1p2.P2.X;
                    let p2y: number = get_state().drawing_p1p2.P2.Y;
                    let label: string = "undefined";
                    if (finding.has_coords) {
                        xCoord = finding.raw_coord.X;
                        yCoord = finding.raw_coord.Y;
                    }
                    if (finding.raw.commonName) {
                        label = `${finding.raw.commonName} (${finding.location_label})`;
                    }
                    if (finding.raw_geoRef.P1.X > 1) {
                        p1x = finding.raw_geoRef.P1.X;
                    }
                    if (finding.raw_geoRef.P1.Y > 1) {
                        p1y = finding.raw_geoRef.P1.Y;
                    }
                    if (finding.raw_geoRef.P2.X > 1) {
                        p2x = finding.raw_geoRef.P2.X;
                    }
                    if (finding.raw_geoRef.P2.Y > 1) {
                        p2y = finding.raw_geoRef.P2.Y;
                    }
                    let index : number = finding.findingNumber;
                    let finding_obj = {
                        "p1xCoord": p1x,
                        "p1yCoord": p1y,
                        "p2xCoord": p2x,
                        "p2yCoord": p2y,
                        "xCoord": xCoord,
                        "yCoord": yCoord,
                        "index": index,
                        "label": label
                    };
                    findings.push(finding_obj);
                    // index++;

                }

            })
        })
    }

    findings_obj["findings"] = findings;
    findings_obj["id_drawing"] = id_drawing;
    let building: string = get_state().buildings.get_building(get_state().id_building).label;
    let floor_label: string = "";
    let drawings: DrawingsCollection = get_state().all_displayable_drawings.get_all_in_building(get_state().id_building);
    drawings.floors.floors.forEach((floor: Floor) => {
        let id_floor: Id_floor = floor.id;
        if (id_floor.equals(get_state().id_floor)) {
            floor_label = floor.label;
            return;
        }
    });
    let today: Date = new Date();
    findings_obj["report_title"] = "Test Report " + building + " " + floor_label
    findings_obj["report_subtitle"] = today.toLocaleDateString()
    let rec: Rectangle = get_current_view_port_map();
    let crop_obj = {
        "left": rec.Left,
        "bottom": rec.Bottom,
        "right": rec.Right,
        "top": rec.Top
    };
    findings_obj["crop"] = crop_obj; 
    return findings_obj;
}


function onclick_print_findings() {
    let obj: any = create_findings_print_object();
    var content = JSON.stringify(obj);
    if (obj.findings.length < 1) {
        alert("No findings are selected to be printed.");
    }
    else {
        Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, true);
        var request = new XMLHttpRequest();
        var url = `${Configuration.floorplan_api_gateway}/api/EocPdf`
        request.open('POST', url, true);
        request.setRequestHeader('Content-type', 'application/json');
        request.responseType = 'blob';

        request.onload = function () {
            // Only handle status code 200
            if (request.status === 200) {
                // Try to find out the filename from the content disposition `filename` value
                var disposition = request.getResponseHeader('content-disposition');
                var matches = /"([^"]*)"/.exec(disposition);
                var filename = (matches != null && matches[1] ? matches[1] : 'file.pdf');

                // The actual download
                var blob = new Blob([request.response], { type: 'application/pdf' });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
            }
            else {
                alert("There was an error. Could not print the findings");
                Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, false);
            }
            Dispatcher.dispatch(Actions.ACTION_SET_PRINTING_FINDINGS, false);
            // some error handling should be done here...
        };
        request.send(content);
    }


}



// WEBPACK FOOTER //
// ./src/ts/ui/menu/FindingsMenu.ts